module.exports = __webpack_public_path__ + "img/shiti_littletitle_bg.c4bc5934.png";